// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__23wHs","row":"ProcedureTreatmentSummary_row__3AG86"};